import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { List, ListItem, ListItemIcon, ListItemText, Grid, Checkbox } from '@mui/material';
import { withTranslation } from 'react-i18next';
import CurrencyDisplay from '../common/CurrencyDisplay';
import ToppingQtyModal from './ToppingQtyModal';

@inject('commonStore', 'menuStore')
@observer
class Topping extends Component {
  state = {
    isModalOpen: false,
    selectedToppingGroup: null,
    selectedTopping: null,
  };

  /**
   * 토핑 수량 모달 열기
   * @param toppingGroup 선택한 토핑 그룹
   * @param topping 선택한 토핑
   */
  openToppingModal = (toppingGroup, topping) => {
    this.setState({
      isModalOpen: true,
      selectedToppingGroup: toppingGroup,
      selectedTopping: topping,
    });
  };

  /** 토핑 수량 모달 닫기 */
  handleCloseToppingModal = () => {
    this.setState({ isModalOpen: false });
  };

  /**
   * 토핑 선택
   * @param toppingGroup 선택한 토핑 그룹
   * @param topping 선택한 토핑
   */
  handleClickTopping = (toppingGroup, topping) => {
    const { t, commonStore } = this.props;

    // 체크된 상태면 체크해제 후 종료
    if (topping.isChecked) {
      topping.qty = 1;
      topping.isChecked = false;
      return;
    }

    // 현재 선택한 토핑 개수 조회
    const selectedToppingQty = toppingGroup.toppings
      .filter(t => t.isChecked)
      .reduce((acc, topping) => acc + topping.qty, 0);

    // 선택 가능한 수량을 초과한 경우 경고 표시 후 종료
    if (toppingGroup.maxCount > 0 && toppingGroup.maxCount <= selectedToppingQty) {
      commonStore.setSnackbar(true, t('menu.error.optionMaxExceeded', { n: toppingGroup.maxCount }));
      return;
    }

    // 토핑 최대 개수가 1보다 크고, 토핑 그룹 최대 개수가 0(무제한)이거나 선택 가능한 남은 수량이 1보다 큰 경우 수량 선택 모달 표시
    if (topping.maxCount > 1 && (toppingGroup.maxCount === 0 || toppingGroup.maxCount - selectedToppingQty > 1)) {
      this.openToppingModal(toppingGroup, topping);
      return;
    }

    // 이 외에는 체크 처리
    topping.isChecked = true;
    topping.qty = 1;
  };

  /** 토핑 수량 선택 완료 */
  handleConfirmModal = qty => {
    const { selectedTopping } = this.state;
    selectedTopping.isChecked = true;
    selectedTopping.qty = qty;
    this.handleCloseToppingModal();
  };

  render() {
    const { menuStore, t } = this.props;
    return (
      <>
        <List className="option-group-list">
          {menuStore.selectedMenu.toppingGroups.map((toppingGroup, index) => (
            <ListItem disableGutters dense key={index} className="option-group">
              <Grid container direction="column">
                <Grid item className="option-group-title">
                  {toppingGroup.name}{' '}
                  {toppingGroup.minCount > 0 && toppingGroup.maxCount > 0 && (
                    <span style={{ color: 'red', fontSize: '12px' }}>
                      ({t('menu.label.optionMin')}
                      {toppingGroup.minCount}, {t('menu.label.optionMax')}
                      {toppingGroup.maxCount})
                    </span>
                  )}
                  {toppingGroup.minCount === 0 && toppingGroup.maxCount > 0 && (
                    <span style={{ fontSize: '12px' }}>
                      ({t('menu.label.optionMax')}
                      {toppingGroup.maxCount})
                    </span>
                  )}
                  {toppingGroup.minCount > 0 && toppingGroup.maxCount === 0 && (
                    <span style={{ color: 'red', fontSize: '12px' }}>
                      ({t('menu.label.optionMin')}
                      {toppingGroup.minCount})
                    </span>
                  )}
                </Grid>
                <Grid item className="option-list">
                  <List>
                    {toppingGroup.toppings.map((topping, toppingIndex) => (
                      <ListItem
                        disableGutters
                        dense
                        button
                        disabled={topping.isSoldOut}
                        key={toppingIndex}
                        onClick={() => this.handleClickTopping(toppingGroup, topping)}
                      >
                        <ListItemIcon>
                          <Checkbox edge="start" checked={topping.isChecked} disabled={topping.isSoldOut} />
                        </ListItemIcon>
                        <ListItemText
                          disableTypography
                          //primary={<span style={{ fontSize: '12pt' }}>{topping.name}</span>}
                          primary={
                            <Grid container gap={1} style={{ fontSize: '16px' }}>
                              <Grid item xs>
                                <span>
                                  {topping.name}
                                  {topping.isSoldOut ? ` (${t('menu.label.soldout')})` : ''}
                                </span>
                              </Grid>
                              <Grid item>{topping.qty > 1 ? `x${topping.qty}` : ''}</Grid>
                              <Grid item style={{ width: '80px', textAlign: 'right' }}>
                                <CurrencyDisplay amount={menuStore.getToppingPrice(topping)} fontWeight="normal" />
                              </Grid>
                            </Grid>
                          }
                          style={{ marginLeft: '-30px' }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              </Grid>
            </ListItem>
          ))}
        </List>

        <ToppingQtyModal
          toppingGroup={this.state.selectedToppingGroup}
          topping={this.state.selectedTopping}
          isOpen={this.state.isModalOpen}
          onClose={this.handleCloseToppingModal}
          onConfirm={this.handleConfirmModal}
        />
      </>
    );
  }
}

export default withTranslation()(Topping);
